import axios from 'axios'
import getHeaders from '../helpers/headers'
import { getError } from 'api/helpers'
import config from '../../constants/endpoints.js'

const getUrl = (url, surveyId = null) => {
  const _url = url.replace(':surveyId', surveyId ? surveyId : '')
  return _url
}

const get = ({ sort, brands, delegations, name, withoutCenters }) =>
  axios({
    method: 'get',
    url: config.endpoints.surveys.get,
    headers: getHeaders(true),
    params: {
      sort, brands, delegations, name, withoutCenters
    }
  })

const getById = (surveyId) =>
  axios({
    method: 'get',
    url: getUrl(config.endpoints.surveys.byId, surveyId),
    headers: getHeaders(true),
  })

const put = (surveyId, survey) =>
  axios({
    method: 'put',
    url: getUrl(config.endpoints.surveys.byId, surveyId),
    headers: getHeaders(true),
    data: survey
  })

const post = (survey) => axios({
  method: 'post',
  url: config.endpoints.surveys.new,
  headers: getHeaders(true),
  data: survey
}).catch(error => {
  throw getError(error)
})

const remove = (surveyId) =>
  axios({
    method: 'delete',
    url: getUrl(config.endpoints.surveys.byId, surveyId),
    headers: getHeaders(true),
  })

const createUrl = (data) => axios({
  method: 'post',
  url: config.endpoints.surveys.url,
  headers: getHeaders(true),
  data
})

export default {
  get,
  getById,
  put,
  post,
  remove,
  createUrl
}
